import { getMinMaxParams } from "./getMinMaxParams";

export const getSceneWidth = () => {
  let params = getMinMaxParams(window['scene'])
  return Math.abs(params.max.z - params.min.z);
}
